<template>
  <div v-if="showModal" class="side__modal opened" id="modal__adding__customers__docs">
    <div class="">
      <div class="side__modal__content">
        <div class="modal__top">
          <div class="modal__header">
            <h3 class="modal__title">{{ $lang.app.CONFIRM_PAYMENT }}</h3>
            <span class="modal__close" @click="closeModal">
            <svg viewBox="0 0 20 20" width="20" height="20"><use xlink:href="@/assets/v2/img/sprite.svg#modal__close"></use></svg></span>
          </div>
        </div>

        <div class="modal__footer">

          <Loader v-if="loading" class="m-5"/>
          <div v-else>
            <div v-for="(payment, index) in payments" :key="payment.id" class="input__group input__add__info">
              <label class="label">{{ $lang.app.PAYMENT }} {{ index + 1 }}.</label>
              <div v-if="payment.attachmentToAgreement" class="flex items-center mb-2">
                <button type="button" class="file__item w-full" @click="loadFile(payment.attachmentToAgreement)">
                  <svg viewBox="0 0 24 24" width="24" height="24">
                    <use xlink:href="@/assets/v2/img/sprite.svg#icon__file__pdf"></use>
                  </svg>
                  <span class="file__item__name">
                    {{ payment.attachmentToAgreement.filename }}
                  </span>
                </button>
              </div>
              <div v-if="payment.payment" class="flex items-center mb-2">
                <button type="button" class="file__item w-full" @click="loadFile(payment.payment)">
                  <svg viewBox="0 0 24 24" width="24" height="24">
                    <use xlink:href="@/assets/v2/img/sprite.svg#icon__file__pdf"></use>
                  </svg>
                  <span class="file__item__name">
                    {{ payment.payment.filename }}
                  </span>
                </button>
              </div>
              <div v-if="payment.paymentOrder" class="flex items-center mb-2">
                <button type="button" class="file__item w-full" @click="loadFile(payment.paymentOrder)">
                  <svg viewBox="0 0 24 24" width="24" height="24">
                    <use xlink:href="@/assets/v2/img/sprite.svg#icon__file__pdf"></use>
                  </svg>
                  <span class="file__item__name">
                    {{ payment.paymentOrder.filename }}
                  </span>
                </button>
              </div>
              <div v-if="payment.receipt">
                <label class="label">{{ $lang.app.RECEIPT }}.</label>
                <div class="flex items-center mb-2">
                  <button type="button" class="file__item w-full" @click="loadFile(payment.receipt)">
                    <svg viewBox="0 0 24 24" width="24" height="24">
                      <use xlink:href="@/assets/v2/img/sprite.svg#icon__file__pdf"></use>
                    </svg>
                    <span class="file__item__name">
                    {{ payment.receipt.filename }}
                  </span>
                  </button>
                  <button v-if="payment.status === applicationPaymentStatusesGetValueByKey('PAID')"
                          type="button" @click="confirm(payment, index)"
                          class="relative button button__icon--left green__lighter ml-4"
                          :disabled="payment.submitting">
                    {{ $lang.app.CONFIRM }}
                    <div v-if="payment.submitting" class="loading-green text-white absolute z-10 w-full rounded-lg h-full top-0 left-0 flex items-center justify-center">
                      <div class="block animate-spin">
                        <RefreshIcon class="w-6 h-6 mirror-y"/>
                      </div>
                    </div>
                  </button>
                  <CheckCircleIcon v-if="payment.status === applicationPaymentStatusesGetValueByKey('CONFIRMED')"
                                   class="ml-4 w-12 h-12 text-green-500"></CheckCircleIcon>
                </div>
              </div>
            </div>
          </div>

          <div class="between__buttons">
            <button type="button" class="button button__modal__close button--cancel"
                    @click="closeModal">{{ $lang.app.CANCEL }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import paymentApi from "../../../../api/employee/payment";
import Loader from "../../../Loader.vue";
import fileApi from "../../../../api/file";
import {getValueByKey as applicationPaymentStatusesGetValueByKey} from "../../../../helpers/constants/applicationPaymentStatuses";

export default {
  components: {Loader},
  data() {
    return {
      showModal: false,
      loading: false,

      application: null,
      payments: [],
    };
  },
  methods: {
    openModal() {
      this.showModal = true
      this.$emitter.emit('body-unscrollable')
    },
    closeModal() {
      this.showModal = false
      this.$emitter.emit('body-scrollable')
    },
    applicationPaymentStatusesGetValueByKey,
    fetchPayments(application) {
      this.loading = true
      paymentApi
          .applicationPayments(application.id)
          .then((res) => {
            this.payments = res.map(item => ({...item, submitting: false}))
          }).finally(() => {
        this.loading = false
      });
    },
    loadFile(file) {
      this.$emitter.emit('open-loader-modal')
      fileApi.getEmployeeApplicationFile(file.id, this.$route.params.applicationId).then(res => {
        this.$emitter.emit('open-file-modal', res.data)
      }).catch(error => {
        this.$snotify.error(error)
      }).finally(() => {
        this.$emitter.emit('close-loader-modal')
      })
    },
    confirm(payment, index) {
      this.payments[index].submitting = true
      paymentApi.confirmApplicationPayment(this.application.id, payment.id)
          .then(() => {
            this.payments[index] = {...this.payments[index], status: this.applicationPaymentStatusesGetValueByKey('CONFIRMED')}
            this.closeModal()
            this.$emitter.emit('refresh-application', {reload: false})
          }).catch(error => {
            this.$snotify.error(error.response.data.message)
          }).finally(() => {
            this.payments[index].submitting = false
          })
    }
  },
  beforeMount() {
    this.$emitter.on('openConfirmPaymentsModal', application => {
      this.openModal()
      this.application = application
      this.fetchPayments(this.application)
    })
  },
  beforeUnmount() {
    this.$emitter.off('openConfirmPaymentsModal')
  }
}
</script>
